import PGlobal from './PGlobal';
import PSprite from './PSprite';
import ObjectPool from './ObjectPool';
import TweenLite from './TweenLite';
import KeyBoard from './keyboard';
import Rect from './component/Rect';

const PREVIEW_ITEM_WIDTH = 44;
const PREVIEW_ITEM_HEIGHT = 44;
const SCOLLING_SPEED = 40 * PREVIEW_ITEM_WIDTH / 1000;
const PREVIEW_ITEM_GAP = 1;

const isMouseRightClick = function(event) {
    var data = event.data;
    return (data.pointerType === 'mouse' || data.pointerType === 'pen') && data.button === 2;
}

export default class PreviewLine extends PSprite {
    constructor(data) {
        super();

        this.data = data;
        this.pool = new ObjectPool();
        var bgRectOptions = {
            fillColor:0x3D3D3D
        }
        this.bgRect = new Rect(bgRectOptions);
        this.addChildAt(this.bgRect, 0);
        this.canvas = new PIXI.Container();
        this.canvas.y = 12;
        this.addChild(this.canvas);
        this.maskGraphic = new PIXI.Graphics();
        this.addChild(this.maskGraphic);
        this.mask = this.maskGraphic;
        this._length = 0;
        this.fixedW = 0;
        this.fixedH = 0;
        this.tween = null;
        this._templateMode = false;

        this.interactive = true;
        this.on('pointerdown', this.onPointerDown, this);
        this.on('pointermove', this.onPointerMove, this);
        this.on('pointerup', this.onPointerUp, this);
        this.on('pointerupoutside', this.onPointerUp, this);
        this.on('pointerout', this.onPointerOut, this);
        this.on('pointerover', this.onPointerOver, this);
        this.shift = new KeyBoard(16);
        this.startIndex = null;
        this.isPointerDown = false;
        this.isPointerOutSide = false;
        this.lastPointerPos = 0;
        this.scrolling = false;
        this.scrollingSpeed = SCOLLING_SPEED;

        this.data.on("selectDict", this.onSelectDictChanged, this);
        this.data.on("playIndex", this.onPlayIndexChanged, this);
    }

    set templateMode(value) {
        this._templateMode = value;
        this.dirty();
    }

    set length(len) {
        if (len != this._length) {
            this._length = len;
            this.dirty();
        }
    }

    onSelectDictChanged(){
        this.dirty();
    }

    onPlayIndexChanged(){
        if(this.data.playIndex !== null && !this.data.isMulti){
            this.moveToSelected();
        }
        if(this.startIndex === null){
            this.startIndex = this.data.playIndex;
        }
    }

    resize(w, h) {
        this.fixedW = w;
        this.fixedH = h;
        this.dirty();
    }

    getSelectedPosition() {
        return this.canvas.toGlobal(new PIXI.Point(this.data.playIndex * (PREVIEW_ITEM_WIDTH + PREVIEW_ITEM_GAP) + PREVIEW_ITEM_WIDTH / 2, 0));
    }

    redraw() {
        this.clear();

        this.bgRect.width = this.fixedW;
        this.bgRect.height = this.fixedH;

        this.maskGraphic.clear();
        this.maskGraphic.beginFill(0x0);
        this.maskGraphic.drawRect(0, 0, this.fixedW, this.fixedH);
        this.maskGraphic.endFill();

        for (let i = 0; i < this._length; ++i) {
            let bg = this.getItem(this.data.selectDict[i]);
            bg.x = (PREVIEW_ITEM_WIDTH + PREVIEW_ITEM_GAP) * i;
            this.canvas.addChild(bg);
            let text = this.getText(i + 1);
            text.x = bg.x + PREVIEW_ITEM_WIDTH / 2;
            text.y = PREVIEW_ITEM_HEIGHT / 2;
            this.canvas.addChild(text);
        }
    }

    onTicker(delta) {
        super.onTicker(delta);
        if(this.scrolling){
            const x = this.boundX(this.canvas.x + this.scrollingSpeed * delta);
            if(x == this.canvas.x){
                this.scrolling = false;
            } else {
                this.canvas.x = x;
                this.onPointerDrag(this.lastPointerPos);
            }
        }
    }

    moveToSelected() {
        let p = this.data.playIndex * (PREVIEW_ITEM_WIDTH + PREVIEW_ITEM_GAP) + PREVIEW_ITEM_WIDTH / 2;
        this.tweenTo(this.fixedW / 2 - p);
    }

    boundX(x){
        let total = this._length * (PREVIEW_ITEM_WIDTH + PREVIEW_ITEM_GAP);
        if (total < this.fixedW || x > 0) {
            x = 0;
        } else if (total + x < this.fixedW) {
            x = this.fixedW - total;
        }
        return x;
    }

    tweenTo(x) {
        x = this.boundX(x);
        if (this.tween) {
            this.tween.kill();
            this.tween = null;
        }
        if (x != this.canvas.x) {
            this.tween = new TweenLite(this.canvas, 0.5, { x: x });
        }
    }

    getItemIndex(x) {
        let index = Math.floor(x / (PREVIEW_ITEM_WIDTH + PREVIEW_ITEM_GAP));
        if (index >= 0 && index < this._length) {
            return index;
        }
        return -1;
    }

    selectRange(start, end) {
        const index = end;
        if (start > end) {
            const tmp = start;
            start = end;
            end = tmp;
        }

        const dict = {};
        for (let i = start; i <= end; i++) {
            dict[i] = true;
        }
        this.data.preview(index, dict);
    }

    onPointerDown(e) {
        if(isMouseRightClick(e)){ return;}
        this.isPointerDown = true;
        this.isPointerOutSide = false;
        let p = e.data.getLocalPosition(this.canvas);
        this.lastPointerPos = e.data;
        const index = this.getItemIndex(p.x);
        if (index === -1) { return; }

        console.log("onpointerdown", this.shift.isDown, this.startIndex);
        if (this.shift.isDown && this.startIndex != null) {
            this.selectRange(this.startIndex, index);
        } else if(index != this.data.playIndex){
            this.startIndex = index;
            this.data.preview(index);
        }
    }

    onPointerOver(e){
        this.isPointerOutSide = false;
        this.onPointerMove(e);
    }

    onPointerMove(e) {
        if (!this.isPointerDown || this.isPointerOutSide) { return; }
        this.lastPointerPos = e.data;
        this.onPointerDrag(e.data);
    }

    onPointerDrag(pos){
        const p = pos.getLocalPosition(this.canvas);
        const x = p.x;
        const index = this.getItemIndex(x);
        if (index === -1) { return; }

        this.selectRange(this.startIndex, index);

        const visibleX = x + this.canvas.x;
        const scrollW = PREVIEW_ITEM_WIDTH * 0.5;
        if(visibleX <= scrollW) {
            this.scrolling = true;
            this.scrollingSpeed = SCOLLING_SPEED;
        } else if(visibleX >= this.fixedW - scrollW){
            this.scrolling = true;
            this.scrollingSpeed = -SCOLLING_SPEED;
        } else {
            this.scrolling = false;
        }
    }

    onPointerUp(e) {
        if(!this.isPointerDown){ return;}
        console.log("onpointerup")
        this.isPointerDown = false;
        this.scrolling = false;
        this.data.play(this.data.playIndex, this.data.selectDict);
    }

    onPointerOut(e) {
        console.log("onpointerout")
        this.scrolling = false;
        this.isPointerOutSide = true;
    }

    clear() {
        let len = this.canvas.children.length;
        for (let i = 0; i < len; ++i) {
            let item = this.canvas.getChildAt(i);
            this.returnObj(item);
        }
        this.canvas.removeChildren();
    }

    getText(index) {
        let text = this.pool.pop("text");
        if (!text) {
            text = new PIXI.Text(index.toString(), { fontFamily: 'Arial', fontSize: 11, fill: 0xaaaaaa, align: 'center' });
            text.label = "text";
            text.anchor.x = 0.5;
            text.anchor.y = 0.5;
        } else {
            text.text = index.toString();
        }
        return text;
    }

    getItem(selected) {
        let item = this.pool.pop(selected ? "selected" : (this._templateMode ? "template" : "unselected"));
        if (!item) {
            item = new PIXI.Graphics();
            if (selected) {
                item.label = "selected";
                item.beginFill(0xF55658);
                item.drawRect(0, 0, PREVIEW_ITEM_WIDTH, PREVIEW_ITEM_HEIGHT);
                item.endFill();
                item.beginFill(0xffffff);
                item.drawRect(2, 2, PREVIEW_ITEM_WIDTH - 4, PREVIEW_ITEM_HEIGHT - 4);
                item.endFill();
            } else if (this._templateMode) {
                const IMAGINARY_LINE_LENGTH = 5;
                const IMAGINARY_GAP_LENGTH = 3;
                item.label = "template";
                item.beginFill(0xffffff);
                item.drawRect(0, 0, PREVIEW_ITEM_WIDTH, PREVIEW_ITEM_HEIGHT);
                item.lineStyle(2, 0xF55658);
                let index = 0;
                let line = 0;
                for (let i = 0; ; ++i) {
                    if (i % 2 == 0) {
                        line = index + IMAGINARY_LINE_LENGTH;
                        if (line > PREVIEW_ITEM_WIDTH) line = PREVIEW_ITEM_WIDTH;
                        item.moveTo(index, 1);
                        item.lineTo(line, 1);
                        item.moveTo(index, PREVIEW_ITEM_HEIGHT - 1);
                        item.lineTo(line, PREVIEW_ITEM_HEIGHT - 1);
                        index = line;
                    } else {
                        index += IMAGINARY_GAP_LENGTH;
                        if (index > PREVIEW_ITEM_WIDTH) index = PREVIEW_ITEM_WIDTH;
                    }
                    if (index >= PREVIEW_ITEM_WIDTH) break;
                }
                index = 0;
                for (let j = 0; ; ++j) {
                    if (j % 2 == 0) {
                        line = index + IMAGINARY_LINE_LENGTH;
                        if (line > PREVIEW_ITEM_HEIGHT) line = PREVIEW_ITEM_HEIGHT;
                        item.moveTo(1, index);
                        item.lineTo(1, line);
                        item.moveTo(PREVIEW_ITEM_WIDTH - 1, index);
                        item.lineTo(PREVIEW_ITEM_WIDTH - 1, line);
                        index = line;
                    } else {
                        index += IMAGINARY_GAP_LENGTH;
                        if (index > PREVIEW_ITEM_HEIGHT) index = PREVIEW_ITEM_HEIGHT;
                    }
                    if (index >= PREVIEW_ITEM_HEIGHT) break;
                }
                item.endFill();
            } else {
                item.label = "unselected";
                item.beginFill(0xffffff);
                item.drawRect(0, 0, PREVIEW_ITEM_WIDTH, PREVIEW_ITEM_HEIGHT);
                item.endFill();
            }
        }
        return item;
    }

    returnObj(obj) {
        this.pool.push(obj.label, obj);
    }
}



// WEBPACK FOOTER //
// ./src/common/scripts/pixi/PreviewLine.js